import { FC } from 'react'

interface CaretDownProps {
  width: number
  height: number
  color?: 'black' | 'grey-500' | 'white'
}

const CaretDown: FC<CaretDownProps> = ({ width, height, color = 'black' }) => {
  const fillColor = {
    white: '#FFFFFF',
    'grey-500': '#75787B',
    black: '#212721',
  }
  const DEFAULT_COLOR = fillColor.black

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8788 0.292893C14.2694 -0.097631 14.9025 -0.097631 15.293 0.292893C15.6836 0.683417 15.6836 1.31658 15.293 1.70711L8.70726 8.29289C8.65844 8.34171 8.60584 8.38442 8.55039 8.42103C8.16223 8.67732 7.63475 8.6346 7.29304 8.29289L0.707257 1.70711C0.316733 1.31658 0.316733 0.683419 0.707257 0.292895C1.09778 -0.0976298 1.73095 -0.0976299 2.12147 0.292894L8.00015 6.17157L13.8788 0.292893Z"
        fill={fillColor[color] || DEFAULT_COLOR}
      />
    </svg>
  )
}

export default CaretDown
